import { FORM_METHOD_TYPES } from "../../../../stateCommon/consts";
import { getHttpListParamsStrings } from "../../../utils/code";
import { METHOD_TEMPLATES } from "../../../utils/consts";
const getDBParams = () => `{
  query:{
    page: source.page,
    size: source.size,
    filter: source.filter,
    sort: source.sort.map(item=>item.k).join(','),
    order: source.sort.map(item=>item.o).join(',')
  }
}`.trim();
export const dbListCount = _options => {
  const info = {
    args: [],
    type: FORM_METHOD_TYPES.request,
    tpl: METHOD_TEMPLATES.list.listCount,
    cgi: ['list', 'count'],
    params: {
      request: getDBParams()
    }
  };
  return info;
};
export const listOrCount = options => {
  const {
    collection,
    cgi
  } = options;
  const isHttp = collection.type === 'http';
  let code;
  if (isHttp) {
    const [queryString, bodyString] = getHttpListParamsStrings(options);
    code = `
{
  query:{
    ${queryString || ''}
  },
  body:{
    ${bodyString || ''}
  }
}
`.trim();
  } else {
    code = cgi === 'list' ? getDBParams() : `
{
  query:source.filter
}
`;
  }
  const info = {
    args: [],
    type: FORM_METHOD_TYPES.request,
    tpl: cgi === 'list' ? METHOD_TEMPLATES.list.list : METHOD_TEMPLATES.list.count,
    cgi: cgi,
    params: {
      request: code.trim()
    }
  };
  return info;
};
//# sourceMappingURL=listCount.js.map
